import asyncThunk from '@/lib/asyncThunk'
import { SMSConfiguration } from '@/out/sms'

type Request = Record<never, never>

export const retrieveSMSConfiguration = asyncThunk<Request, SMSConfiguration>({
  name: 'sms/retrieve',
  uri: '/sms',
})
